import React, { FunctionComponent, useEffect, useState } from "react";
import {
    IGPSData,
    IGCPBigQueryJob,
    IPolygon,
    IProfileRecord,
    IGPSProfile,
    IGPSBenchmarkCommonData,
} from "../../../Models/Models";
import { ReportInnerWrapper } from "../../Common/";
import { HHChar } from "./HHCharacteristics/HHCharContainer";
import GPSInsightsVolume from "./Volume/GPSInsightsVolume";
import GPSTradeArea from "./TradeArea/GPSTradeArea";
import VisitorBehaviorsContainer from "./VisitorBehaviors/VisitorBehaviorsContainer";
import { IMobilyticsBenchmarkItem } from "../../../Models/IMobilyticsBenchmarkItem";
import { RenderType } from "../../../Enums/RenderType";
import { DigitalShareAppType } from "../../../Enums/DigitalShareAppType";

interface IGPSInsightsReportProps {
  storeData: IGPSData[];
  polygons: IPolygon[];
  selectedGpsInsightForReportView: IGCPBigQueryJob[];
  benchmarkData?: IGPSData;
  benchmarkCommonData?: IGPSBenchmarkCommonData;
  benchmarkItems: IMobilyticsBenchmarkItem[];
  currentBenchmarkPolygon: IPolygon;
  renderType: RenderType;
}

export const GPSInsightsReport: FunctionComponent<IGPSInsightsReportProps> = (
    props: IGPSInsightsReportProps
) => {
    const {
        storeData,
        polygons,
        selectedGpsInsightForReportView,
        benchmarkData,
        benchmarkCommonData,
        renderType,
    } = props;

    const [mapReady, setMapReady] = useState<boolean>(false);

    const mutateSegData = (data: IGPSProfile[]): IProfileRecord[] => {
        return data.map((item: IGPSProfile) => {
            return {
                seg: item.segment,
                pct: item.actualPercent,
                core: item.core,
                index: item.index,
            };
        });
    };

    const location1Name
    = selectedGpsInsightForReportView.length > 0
        ? selectedGpsInsightForReportView[0].jobPolygon.name
        : null;
    const location2Name
    = selectedGpsInsightForReportView.length > 1
        ? selectedGpsInsightForReportView[1].jobPolygon.name
        : null;

    const onMapReady = () => {
        setMapReady(true);
    };

    /** Failsafe for "mapReady" state if the Google map fails to load */
    useEffect(() => {
        const onMapReadyFailsafe = setTimeout(() => setMapReady(true), 10000);
        return () => clearTimeout(onMapReadyFailsafe);
    }, []);

    return (
        <>
            {
                mapReady &&
                    <>
                        <GPSTradeArea
                            storeData={storeData}
                            storePolygon={polygons}
                            selectedGpsInsightForReportView={props.selectedGpsInsightForReportView}
                            benchmarkItems={props.benchmarkItems}
                            polygons={polygons}
                            benchmarkData={benchmarkData}
                            renderType={renderType}
                        />
                        <HHChar
                            storeProfileData={mutateSegData(storeData[0].profile)}
                            storeData={storeData[0]}
                            benchmarkData={benchmarkData}
                            benchmarkProfileData={
                                benchmarkData ? mutateSegData(benchmarkData.profile) : null
                            }
                            location1Name={location1Name}
                            location2Name={location2Name}
                            renderType={renderType}
                            app={DigitalShareAppType.Mobilytics}
                        />
                        <GPSInsightsVolume
                            location1Name={location1Name}
                            location2Name={location2Name}
                            {...props}
                            storeData={storeData[0]}
                        />
                    </>
            }
            <VisitorBehaviorsContainer
                benchmarkCommonData={benchmarkCommonData}
                location1Name={location1Name}
                location2Name={location2Name}
                renderType={renderType}
                app={DigitalShareAppType.Mobilytics}
                onMapReady={onMapReady}
            />
        </>
    );
};
